<div>
  <div class="row">
    <div class="col-sm-8 col-md-7">
      <div style="display: flex">
        <h1 class="aru-title">
          Inspections / Flags
          <i
            *ngIf="canExport && activeTab !== 'closed'"
            (click)="downloadCsv(activeTab)"
            style="font-size: 17px; cursor: pointer"
            class="fa fa-file-text-o"></i>
        </h1>

        <ng-container *ngIf="activeTab !== 'inprogress'"> </ng-container>
      </div>
    </div>

    <div class="col-sm-4 col-md-5">
      <div class="aru-tabs lg">
        <button
          type="button"
          [ngClass]="{ active: activeTab === 'open' }"
          (click)="setTab('open')"
          class="btn btn-square">
          <span>Open</span>
        </button>
        <button
          type="button"
          [ngClass]="{ active: activeTab === 'inprogress' }"
          g
          (click)="setTab('inprogress')"
          class="btn btn-square">
          <span>In Progress</span>
        </button>

        <button
          type="button"
          [ngClass]="{ active: activeTab === 'closed' }"
          (click)="setTab('closed')"
          class="btn btn-square">
          <span>Closed</span>
        </button>
      </div>
    </div>
    <div class="col-md-12" *ngIf="activeTab === 'inprogress'">
      <app-search-filter
        [filters]="definedFilters"
        [params]="params"
        (filtersUpdated)="filtersUpdated($event)"></app-search-filter>
    </div>
  </div>

  <div class="search-filter-wrapper">
    <div class="search-bar">
      <app-inspection-filter-cards
        #filterCards
        (searchTermUpdated)="setSearchTerm($event)"
        *ngIf="activeTab === 'open' || activeTab === 'closed'"></app-inspection-filter-cards>
    </div>
    <!-- Assignee Filter -->
    <app-inspection-assignee-filter
      [filteredAssignees]="filteredAssignees"
      (assigneeChange)="updateAssignees($event)"
      *ngIf="activeTab === 'open'"></app-inspection-assignee-filter>
    <!-- Product Type Filter -->
    <app-inspection-product-filter
      [productTypes]="productTypes"
      (productTypesChanged)="filterProductTypes($event)"
      *ngIf="activeTab === 'open'"></app-inspection-product-filter>
  </div>

  <br />
  <br />

  <div id="headers" *ngIf="activeTab === 'open'">
    <div style="display: flex; align-items: center" class="col-lg-12">
      <h6 class="col-lg-10 pl-0 pr-0">
        Prepare Flags for Rec Letter
        <span
          >({{ (prepare | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length }})</span
        >
      </h6>
      <div class="dropdown" style="display: inline-block; width: 10%; text-align: right" dropdown>
        <button type="button" class="btn btn-bulk" dropdownToggle>
          <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu right" *dropdownMenu>
          <h6 class="dropdown-header">Please select the sorting order</h6>
          <a
            class="dropdown-item"
            [class.highlighted]="activePrepareFlagsSort === 'highestScored'"
            (click)="sortPrepareFlagsHighestSore()">
            Highest scored first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activePrepareFlagsSort === 'oldestAccepted'"
            (click)="sortPrepareFlagsOldestAccepted()"
            >Oldest accepted first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activePrepareFlagsSort === 'newestAccepted'"
            (click)="sortPrepareFlagsNewestAccepted()"
            >Newest accepted first</a
          >
        </div>
      </div>
    </div>

    <div style="display: flex; align-items: center" class="col-lg-12">
      <h6 class="col-lg-10 pl-2 pr-0">
        Flags Preparation in Progress
        <span
          >({{ (inProgress | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length }})</span
        >
      </h6>
      <div class="dropdown" style="display: inline-block; width: 10%; text-align: right" dropdown>
        <button type="button" class="btn btn-bulk" dropdownToggle>
          <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu right" *dropdownMenu>
          <h6 class="dropdown-header">Please select the sorting order</h6>
          <a
            class="dropdown-item"
            [class.highlighted]="activeInProgressSort === 'highestScored'"
            (click)="sortInProgressHighestSore()">
            Highest scored first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeInProgressSort === 'oldestAccepted'"
            (click)="sortInProgressOldestAccepted()"
            >Oldest accepted first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeInProgressSort === 'newestAccepted'"
            (click)="sortInProgressNewestAccepted()"
            >Newest accepted first</a
          >
        </div>
      </div>
    </div>

    <div style="display: flex; align-items: center" class="col-lg-12">
      <h6 class="col-lg-10 pl-2 pr-0">
        Rec Letter Sent
        <span
          >({{ (letterSent | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length }})</span
        >
      </h6>
      <div class="dropdown" style="display: inline-block; width: 10%; text-align: right" dropdown>
        <button type="button" class="btn btn-bulk" dropdownToggle>
          <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu right" *dropdownMenu>
          <h6 class="dropdown-header">Please select the sorting order</h6>
          <a
            class="dropdown-item"
            [class.highlighted]="activeLetterSentSort === 'highestScored'"
            (click)="sortLetterSentHighestSore()">
            Highest scored first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeLetterSentSort === 'oldestAccepted'"
            (click)="sortLetterSentOldestAccepted()"
            >Oldest accepted first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeLetterSentSort === 'newestAccepted'"
            (click)="sortLetterSentNewestAccepted()"
            >Newest accepted first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeLetterSentSort === 'LetterSentEarliestDueDateFirst'"
            (click)="sortLetterSentDueDateFirst('asc', 'LetterSentEarliestDueDateFirst')"
            >Earliest due date first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeLetterSentSort === 'LetterSentLatestDueDateFirst'"
            (click)="sortLetterSentDueDateFirst('desc', 'LetterSentLatestDueDateFirst')"
            >Latest due date first</a
          >
        </div>
      </div>
    </div>

    <div style="display: flex; align-items: center" class="col-lg-12">
      <h6 class="col-lg-10 pl-3 pr-0">
        Resolution in Progress<span
          >({{ (resolution | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length }})</span
        >
      </h6>
      <div class="dropdown" style="display: inline-block; width: 10%; text-align: right" dropdown>
        <button type="button" class="btn btn-bulk" dropdownToggle>
          <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu right" *dropdownMenu>
          <h6 class="dropdown-header">Please select the sorting order</h6>
          <a
            class="dropdown-item"
            [class.highlighted]="activeResolutionSort === 'highestScored'"
            (click)="sortResolutionHighestSore()">
            Highest scored first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeResolutionSort === 'oldestAccepted'"
            (click)="sortResolutionOldestAccepted()"
            >Oldest accepted first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeResolutionSort === 'newestAccepted'"
            (click)="sortResolutionNewestAccepted()"
            >Newest accepted first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeResolutionSort === 'resolutionEarliestDueDateFirst'"
            (click)="sortResolutionDueDateFirst('asc', 'resolutionEarliestDueDateFirst')"
            >Earliest due date first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeResolutionSort === 'resolutionLatestDueDateFirst'"
            (click)="sortResolutionDueDateFirst('desc', 'resolutionLatestDueDateFirst')"
            >Latest due date first</a
          >
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="activeTab === 'open'">
    <div
      *ngIf="!(isletterSent() && isPrepare() && isProgress() && isresolution()); else noResult"
      id="wrapper"
      #wrapper
      [ngStyle]="{ display: activeTab === 'open' ? 'block' : 'none' }">
      <div>
        <div class="column">
          <div class="scrollable for-scroll">
            <div
              class="card-inspection"
              *ngFor="
                let inspection of prepare | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/review/flagManager/' + inspection.id"
              [ngClass]="getInspectionScoreClass(inspection)">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                    <div class="days" [ngClass]="getDaysClass(inspection)">
                      {{ inspection.daysSinceAccepted }} day{{ inspection.daysSinceAccepted > 1 ? 's' : '' }}
                    </div>
                  </div>

                  <div style="text-align: center; font-weight: 500; font-size: 1.1em" class="badge-wrapper">
                    <span *ngIf="scoresEnabled && inspection.flaggingScore">
                      <span class="score-badge"><i style="font-size: 14px" class="fa fa-warning"></i></span>
                      <br />
                    </span>
                    <div *ngIf="scoresEnabled && inspection.flaggingScore" class="score">
                      {{ inspection.flaggingScore }}
                    </div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px">
                <div
                  class="avatar"
                  style="margin-left: 0px"
                  *ngIf="inspection.assignee"
                  (click)="openAssignmentModal(inspection, 'prepare'); $event.stopPropagation()">
                  {{ getInitials(inspection.assignee.name) }}
                </div>
                <div class="tooltip-container">
                  <div
                    class="default-svg tooltip-container"
                    *ngIf="!inspection.assignee && canAssign"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'prepare'); $event.stopPropagation()">
                    <img src="assets/img/non-assign.svg" style="margin-left: 4px" alt="" />
                  </div>
                  <div
                    *ngIf="!inspection.assignee && canAssign"
                    class="hover-svg tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'prepare'); $event.stopPropagation()">
                    <img
                      *ngIf="inspection.flaggingScore"
                      src="assets/img/non-assign-onhover.svg"
                      style="margin-left: 4px"
                      alt="" />
                    <img
                      *ngIf="!inspection.flaggingScore"
                      src="assets/img/non-assign.svg"
                      style="margin-left: 4px"
                      alt="" />
                  </div>
                </div>
                <span style="line-height: 35px; font-size: 0.9em" class="float-right policy-number"
                  >#{{ inspection.policyNumber }}</span
                >
                <br style="clear: both" />
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="scrollable for-scroll">
            <div
              class="card-inspection"
              [ngClass]="getInspectionScoreClass(inspection)"
              *ngFor="
                let inspection of inProgress | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/review/flagManager/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                    <div class="days" [ngClass]="getDaysClass(inspection)">
                      {{ inspection.daysSinceAccepted }} day{{ inspection.daysSinceAccepted > 1 ? 's' : '' }}
                    </div>
                  </div>

                  <div style="text-align: center; font-weight: 500; font-size: 1.1em" class="badge-wrapper">
                    <span *ngIf="scoresEnabled && inspection.flaggingScore">
                      <span class="score-badge"><i style="font-size: 14px" class="fa fa-warning"></i></span>
                      <br />
                    </span>
                    <div *ngIf="scoresEnabled && inspection.flaggingScore" class="score">
                      {{ inspection.flaggingScore }}
                    </div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div style="padding-top: 10px" class="d-flex justify-content-between">
                <span>
                  <div
                    class="tooltip-container"
                    data-tooltip="View"
                    [routerLink]="'/inspection/review/flagManager/' + inspection.id">
                    <!-- Default SVG -->
                    <span (click)="$event.stopPropagation()" class="default-svg has-score-icon-hover">
                      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="12" fill="white" />
                        <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                        <path
                          d="M18.1724 11.3225C17.0426 9.11817 14.8059 7.62671 12.2449 7.62671C9.68383 7.62671 7.44653 9.11921 6.31736 11.3228C6.2697 11.417 6.24487 11.5212 6.24487 11.6268C6.24487 11.7325 6.2697 11.8366 6.31736 11.9309C7.44716 14.1353 9.68383 15.6267 12.2449 15.6267C14.8059 15.6267 17.0432 14.1342 18.1724 11.9307C18.22 11.8364 18.2449 11.7322 18.2449 11.6266C18.2449 11.521 18.22 11.4168 18.1724 11.3225ZM12.2449 14.6267C11.6515 14.6267 11.0715 14.4508 10.5782 14.1211C10.0848 13.7915 9.70029 13.3229 9.47323 12.7748C9.24617 12.2266 9.18676 11.6234 9.30251 11.0414C9.41827 10.4595 9.70399 9.92495 10.1235 9.50539C10.5431 9.08583 11.0777 8.80011 11.6596 8.68436C12.2415 8.5686 12.8447 8.62801 13.3929 8.85507C13.9411 9.08214 14.4096 9.46665 14.7393 9.96C15.0689 10.4534 15.2449 11.0334 15.2449 11.6267C15.2451 12.0207 15.1676 12.4109 15.0169 12.775C14.8662 13.1391 14.6452 13.4699 14.3666 13.7485C14.088 14.0271 13.7572 14.2481 13.3932 14.3988C13.0291 14.5494 12.6389 14.6269 12.2449 14.6267ZM12.2449 9.62671C12.0664 9.62921 11.889 9.65577 11.7176 9.70567C11.8589 9.89769 11.9267 10.134 11.9087 10.3717C11.8907 10.6094 11.7881 10.8328 11.6196 11.0014C11.451 11.17 11.2276 11.2726 10.9899 11.2905C10.7521 11.3085 10.5158 11.2407 10.3238 11.0994C10.2145 11.5023 10.2342 11.9292 10.3803 12.3203C10.5263 12.7113 10.7913 13.0467 11.1379 13.2792C11.4845 13.5117 11.8954 13.6297 12.3126 13.6166C12.7298 13.6034 13.1323 13.4597 13.4636 13.2057C13.7949 12.9518 14.0382 12.6003 14.1592 12.2009C14.2803 11.8014 14.273 11.374 14.1385 10.9789C14.0039 10.5838 13.7489 10.2408 13.4092 9.99824C13.0695 9.75567 12.6623 9.62573 12.2449 9.62671Z"
                          fill="#2763CD" />
                      </svg>
                    </span>

                    <!-- Hover SVG -->
                    <span class="hover-svg">
                      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 32 33" fill="none">
                        <path
                          d="M31.3333 16.8696C31.3333 25.3596 24.4669 32.2396 16 32.2396C7.53307 32.2396 0.666667 25.3596 0.666667 16.8696C0.666667 8.3796 7.53307 1.49967 16 1.49967C24.4669 1.49967 31.3333 8.3796 31.3333 16.8696Z"
                          stroke="white"
                          stroke-opacity="0.16"
                          stroke-width="1.33333" />
                        <path
                          d="M24.23 15.9642C22.7236 13.0183 19.7414 11.0251 16.3267 11.0251C12.9119 11.0251 9.92887 13.0197 8.42331 15.9645C8.35977 16.0905 8.32666 16.2297 8.32666 16.3708C8.32666 16.512 8.35977 16.6512 8.42331 16.7772C9.9297 19.7231 12.9119 21.7162 16.3267 21.7162C19.7414 21.7162 22.7245 19.7217 24.23 16.7769C24.2936 16.6509 24.3267 16.5117 24.3267 16.3706C24.3267 16.2294 24.2936 16.0902 24.23 15.9642ZM16.3267 20.3799C15.5355 20.3799 14.7622 20.1447 14.1044 19.7042C13.4466 19.2637 12.9339 18.6375 12.6311 17.9049C12.3284 17.1724 12.2492 16.3662 12.4035 15.5885C12.5579 14.8108 12.9388 14.0965 13.4982 13.5358C14.0576 12.9751 14.7704 12.5933 15.5463 12.4386C16.3222 12.2839 17.1265 12.3633 17.8574 12.6667C18.5883 12.9702 19.213 13.484 19.6525 14.1433C20.0921 14.8026 20.3267 15.5778 20.3267 16.3707C20.3269 16.8973 20.2236 17.4187 20.0227 17.9052C19.8218 18.3918 19.5271 18.8338 19.1557 19.2062C18.7842 19.5785 18.3431 19.8738 17.8577 20.0752C17.3723 20.2766 16.852 20.3801 16.3267 20.3799ZM16.3267 13.6979C16.0886 13.7013 15.8522 13.7367 15.6236 13.8034C15.812 14.06 15.9024 14.3758 15.8784 14.6935C15.8544 15.0112 15.7177 15.3098 15.4929 15.535C15.2681 15.7603 14.9703 15.8974 14.6533 15.9214C14.3363 15.9455 14.0213 15.8549 13.7653 15.666C13.6195 16.2044 13.6458 16.775 13.8405 17.2975C14.0352 17.8201 14.3885 18.2683 14.8507 18.5791C15.3129 18.8898 15.8607 19.0475 16.4169 19.0299C16.9732 19.0123 17.5099 18.8203 17.9516 18.4809C18.3933 18.1415 18.7177 17.6718 18.8791 17.138C19.0405 16.6042 19.0309 16.033 18.8515 15.505C18.6721 14.9769 18.332 14.5186 17.8791 14.1944C17.4261 13.8703 16.8832 13.6966 16.3267 13.6979Z"
                          fill="white" />
                      </svg>
                    </span>
                  </div>

                  <div
                    class="avatar"
                    *ngIf="inspection.assignee"
                    (click)="openAssignmentModal(inspection, 'inProgress'); $event.stopPropagation()">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div class="tooltip-container">
                    <div
                      class="default-svg tooltip-container"
                      *ngIf="!inspection.assignee && canAssign"
                      data-tooltip="Assign admin"
                      (click)="openAssignmentModal(inspection, 'inProgress'); $event.stopPropagation()">
                      <img src="assets/img/non-assign.svg" style="margin-left: 4px" alt="" />
                    </div>
                    <div
                      *ngIf="!inspection.assignee && canAssign"
                      class="hover-svg tooltip-container"
                      data-tooltip="Assign admin"
                      (click)="openAssignmentModal(inspection, 'inProgress'); $event.stopPropagation()">
                      <img
                        *ngIf="inspection.flaggingScore"
                        src="assets/img/non-assign-onhover.svg"
                        style="margin-left: 4px"
                        alt="" />
                      <img
                        *ngIf="!inspection.flaggingScore"
                        src="assets/img/non-assign.svg"
                        style="margin-left: 4px"
                        alt="" />
                    </div>
                  </div>
                </span>
                <span style="font-size: 0.9em" class="float-right policy-number"
                  >#{{ inspection.policyNumber }}
                  <br />
                  Prepared {{ inspection.totalDefinedFlags }}/{{ inspection.totalFlags }}
                  <div class="progress" style="display: inline-flex; width: 70px; margin: 0 10px 0 0; height: 5px">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      [ngStyle]="{ width: (100 * inspection.totalDefinedFlags) / inspection.totalFlags + '%' }"></div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="scrollable for-scroll">
            <div
              class="card-inspection"
              *ngFor="
                let inspection of letterSent | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/review/flagManager/' + inspection.id"
              [ngClass]="getInspectionScoreClass(inspection)">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    title="{{ inspection.earliestDeadline?.substr(0, 10) }}"
                    [ngStyle]="{ color: inspection.deadlineIsPast ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.deadlineIsPast">!</span>
                    <br *ngIf="inspection.deadlineIsPast" />
                    {{ inspection.earliestDeadlineString }}
                    <div *ngIf="scoresEnabled && inspection.flaggingScore" class="score" style="margin-top: 5px">
                      {{ inspection.flaggingScore }}
                    </div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px">
                <button
                  *ngIf="inspection.overdue && canRemind"
                  class="btn btn-link float-left underline"
                  style="padding: 6px 0"
                  (click)="sendReminderDue($event, inspection)">
                  Send reminder
                </button>

                <div
                  class="avatar"
                  style="margin-left: 0px"
                  *ngIf="inspection.assignee"
                  (click)="openAssignmentModal(inspection, 'letterSent'); $event.stopPropagation()">
                  {{ getInitials(inspection.assignee.name) }}
                </div>
                <div class="tooltip-container">
                  <div
                    class="default-svg tooltip-container"
                    *ngIf="!inspection.assignee && canAssign"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'letterSent'); $event.stopPropagation()">
                    <img src="assets/img/non-assign.svg" style="margin-left: 4px" alt="" />
                  </div>
                  <div
                    *ngIf="!inspection.assignee && canAssign"
                    class="hover-svg tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'letterSent'); $event.stopPropagation()">
                    <img
                      *ngIf="inspection.flaggingScore"
                      src="assets/img/non-assign-onhover.svg"
                      style="margin-left: 4px"
                      alt="" />
                    <img
                      *ngIf="!inspection.flaggingScore"
                      src="assets/img/non-assign.svg"
                      style="margin-left: 4px"
                      alt="" />
                  </div>
                </div>
                <span style="color: #aaa; line-height: 35px; font-size: 0.9em" class="float-right"
                  >#{{ inspection.policyNumber }}</span
                >
                <br style="clear: both" />
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="scrollable for-scroll">
            <div
              class="card-inspection"
              *ngFor="
                let inspection of resolution | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/review/flagManager/' + inspection.id"
              [ngClass]="getInspectionScoreClass(inspection)">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    [ngStyle]="{ color: inspection.earliestNonResolvedDeadlineIsPast ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.earliestNonResolvedDeadlineIsPast">!</span>
                    <br *ngIf="inspection.earliestNonResolvedDeadlineIsPast" />
                    {{ inspection.earliestNonResolvedDeadline }}
                    <div *ngIf="scoresEnabled && inspection.flaggingScore" class="score" style="margin-top: 5px">
                      {{ inspection.flaggingScore }}
                    </div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px">
                Processed {{ inspection.totalResolvedFlags }}/{{ inspection.totalFlags }}
                <div class="progress" style="display: inline-flex; width: 70px; margin: 0 10px 0 0; height: 5px">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    [ngStyle]="{ width: (100 * inspection.totalResolvedFlags) / inspection.totalFlags + '%' }"></div>
                </div>

                <div
                  class="avatar"
                  style="margin-left: 0px"
                  *ngIf="inspection.assignee"
                  (click)="openAssignmentModal(inspection, 'resolution'); $event.stopPropagation()">
                  {{ getInitials(inspection.assignee.name) }}
                </div>
                <div class="tooltip-container">
                  <div
                    class="default-svg tooltip-container"
                    *ngIf="!inspection.assignee && canAssign"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'resolution'); $event.stopPropagation()">
                    <img src="assets/img/non-assign.svg" style="margin-left: 4px" alt="" />
                  </div>
                  <div
                    *ngIf="!inspection.assignee && canAssign"
                    class="hover-svg tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'resolution'); $event.stopPropagation()">
                    <img
                      *ngIf="inspection.flaggingScore"
                      src="assets/img/non-assign-onhover.svg"
                      style="margin-left: 4px"
                      alt="" />
                    <img
                      *ngIf="!inspection.flaggingScore"
                      src="assets/img/non-assign.svg"
                      style="margin-left: 4px"
                      alt="" />
                  </div>
                </div>
                <span style="color: #aaa; line-height: 35px; font-size: 0.9em" class="float-right"
                  >#{{ inspection.policyNumber }}
                </span>
                <br style="clear: both" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noResult>
      <div *ngIf="!loading" id="search-wrapper" class="no-result">
        <h2>No search results.</h2>
        <button class="btn btn-danger" (click)="reset()">Reset All</button>
      </div>
      <div *ngIf="loading && activeTab === 'open'" id="search-wrapper" class="no-result">
        <div class="spinner-wrapper">
          <span class="spinner"></span>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <div *ngIf="activeTab === 'closed'">
    <div class="table-wrapper">
      <table class="table aru pointer">
        <thead>
          <tr>
            <th (click)="setOrder('customer.name')">
              Customer
              <i class="fa" [ngClass]="getOrderIcon('customer.name')"></i>
            </th>
            <th (click)="setOrder('location.address')">
              Location Address
              <i class="fa" [ngClass]="getOrderIcon('location.address')"></i>
            </th>
            <th (click)="setOrder('location.city')">
              City
              <i class="fa" [ngClass]="getOrderIcon('location.city')"></i>
            </th>
            <th (click)="setOrder('location.state')">
              State
              <i class="fa" [ngClass]="getOrderIcon('location.state')"></i>
            </th>
            <th (click)="setOrder('policy.number')">
              Policy No.
              <i class="fa" [ngClass]="getOrderIcon('policy.number')"></i>
            </th>
            <th (click)="setOrder('vendor.firstName')">
              Vendor
              <i class="fa" [ngClass]="getOrderIcon('vendor.firstName')"></i>
            </th>
            <th (click)="setOrder('inspector.firstName')">
              Inspector
              <i class="fa" [ngClass]="getOrderIcon('inspector.firstName')"></i>
            </th>

            <th (click)="setOrder('includedResolvedFlagsPercentage')">
              Resolved % <i class="fa" [ngClass]="getOrderIcon('includedResolvedFlagsPercentage')"></i>
            </th>

            <th (click)="setOrder('inspection.completed')">
              Completed
              <i class="fa" [ngClass]="getOrderIcon('inspection.completed')"></i>
            </th>

            <th (click)="setOrder('inspection.underwrintingClosed')">
              Closed
              <i class="fa" [ngClass]="getOrderIcon('inspection.underwrintingClosed')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of closed" (click)="open($event, row.id)">
            <td>{{ row.customerName }}</td>
            <td>{{ row.address }}</td>
            <td>{{ row.city }}</td>
            <td>{{ row.state }}</td>
            <td>{{ row.policyNumber }}</td>
            <td>{{ row.vendor?.name }}</td>
            <td>{{ row.inspector?.name }}</td>
            <td>{{ row.includedResolvedFlagsPercentage | number: '1.0-0' }}</td>
            <td>{{ dateAsString(row.completed) }}</td>
            <td>{{ dateAsString(row.underwrintingClosed) }}</td>
          </tr>
          <tr>
            <td *ngIf="!closed?.length && !loading" [attr.colspan]="11" style="text-align: center">
              No records were found.
            </td>
            <div *ngIf="loading">
              <ngx-loading
                [show]="loading"
                [config]="{
                  backdropBorderRadius: '3px',
                  animationType: ngxLoadingAnimationTypes.threeBounce,
                  primaryColour: primaryColour,
                  secondaryColour: secondaryColour
                }">
              </ngx-loading>
            </div>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination
      *ngIf="closedCount && !loading"
      class="pagination"
      [(ngModel)]="page"
      [totalItems]="closedCount"
      [itemsPerPage]="pageSize"
      [maxSize]="5"
      [boundaryLinks]="true"
      [rotate]="false"
      (pageChanged)="onPageChanged($event.page)">
    </pagination>
  </div>

  <div *ngIf="activeTab === 'inprogress'">
    <div class="table-wrapper">
      <table class="table aru pointer">
        <thead>
          <tr>
            <th (click)="setOrder('customer_name')">
              Customer
              <i class="fa" [ngClass]="getOrderIcon('customer_name')"></i>
            </th>
            <th (click)="setOrder('location_address')">
              Location Address
              <i class="fa" [ngClass]="getOrderIcon('location_address')"></i>
            </th>
            <th (click)="setOrder('location_city')">
              City
              <i class="fa" [ngClass]="getOrderIcon('location_city')"></i>
            </th>
            <th (click)="setOrder('location_state')">
              State
              <i class="fa" [ngClass]="getOrderIcon('location_state')"></i>
            </th>
            <th (click)="setOrder('policy_number')">
              Policy No.
              <i class="fa" [ngClass]="getOrderIcon('policy_number')"></i>
            </th>
            <th (click)="setOrder('policy_effectiveDate')">
              Effective Date
              <i class="fa" [ngClass]="getOrderIcon('policy_effectiveDate')"></i>
            </th>
            <th (click)="setOrder('sent_email_sentDate')">
              Rec Letter Sent
              <i class="fa" [ngClass]="getOrderIcon('sent_email_sentDate')"></i>
            </th>

            <th (click)="setOrder('inspection_violationActionRequiredDeadline')">
              Rec Due Date

              <i class="fa" [ngClass]="getOrderIcon('inspection_violationActionRequiredDeadline')"></i>
            </th>

            <th (click)="setOrder('flagTotalCount')">
              No. of Recs
              <i class="fa" [ngClass]="getOrderIcon('flagTotalCount')"></i>
            </th>

            <th (click)="setOrder('flagCount')">
              # Completed Recs
              <i class="fa" [ngClass]="getOrderIcon('flagCount')" style="align-items: center; display: flex"></i>
            </th>

            <th>
              Rec Letter
              <i></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of in_ProgressTable" (click)="open($event, row.inspection_id)">
            <td class="wrap-headings-body">{{ row.customer_name }}</td>
            <td class="wrap-headings-body">{{ row.location_address }}</td>
            <td class="wrap-headings-body">{{ row.location_city }}</td>
            <td class="wrap-headings-body">{{ row.location_state }}</td>
            <td class="wrap-headings-body">{{ row.policy_number + ' - ' + row.location_number }}</td>
            <td>{{ dateAsString(row.policy_effectiveDate) }}</td>
            <td>{{ dateAsString(row.sent_email_sentDate) }}</td>
            <td>{{ dateAsString(row.inspection_violationActionRequiredDeadline) }}</td>
            <td>{{ row.flagTotalCount }}</td>
            <td>{{ row.flagCount }}</td>
            <td>
              <button
                [disabled]="!row.inspection_hash"
                type="button"
                (click)="openLetter(row.inspection_hash)"
                class="aru btn btn-primary btn-rec-letter"
                style="width: unset">
                <i class="fa fa-external-link"></i>
              </button>
            </td>
          </tr>
          <tr>
            <td *ngIf="!in_ProgressTable?.length && !loading" [attr.colspan]="11" style="text-align: center">
              No records were found.
            </td>
            <div *ngIf="loading">
              <ngx-loading
                [show]="loading"
                [config]="{
                  backdropBorderRadius: '3px',
                  animationType: ngxLoadingAnimationTypes.threeBounce,
                  primaryColour: primaryColour,
                  secondaryColour: secondaryColour
                }">
              </ngx-loading>
            </div>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination
      *ngIf="in_ProgressTableCount && !loading"
      class="pagination"
      [(ngModel)]="page"
      [totalItems]="in_ProgressTableCount"
      [itemsPerPage]="pageSize"
      [maxSize]="5"
      [boundaryLinks]="true"
      [rotate]="false"
      (pageChanged)="onPageChanged($event.page)">
    </pagination>
  </div>
</div>

<app-admin-assignment #assignmentModal (onConfirm)="handleConfirm($event)">></app-admin-assignment>
